import React, { createContext, useState } from 'react';

const AppContext = createContext();

const AppProvider = ({ children }) => {
    const [isLoading, setIsLoading] = useState(false);

    const [user, setUser] = useState({});

    return (
        <AppContext.Provider value={{ isLoading, setIsLoading, user, setUser }}>
            {children}
        </AppContext.Provider>
    );
};

export { AppContext, AppProvider };